import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import LanguageToggle from "@/components/LanguageToggle";
import Logo from "@/components/Logo";

const ROLE_KEY = { admin: "common.admin", teacher: "common.teacher", student: "common.student" };

export default function AppLayout({ children }) {
  const { user, logout } = useAuth();
  const { t } = useI18n();

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 bg-primary text-primary-foreground shadow-lg">
        <div className="h-1.5 w-full bg-secondary" />
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-20 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Logo size="md" chip />
            <Badge className="hidden md:inline-flex ml-1 rounded-full bg-white/10 text-white border-0 font-semibold">
              {t(ROLE_KEY[user.role])}
            </Badge>
          </div>
          <div className="flex items-center gap-2 sm:gap-4">
            <LanguageToggle onDark />
            <div className="hidden sm:flex flex-col items-end leading-tight">
              <span className="text-sm font-bold" data-testid="current-user-name">{user.name}</span>
              <span className="text-xs text-white/60">@{user.username}</span>
            </div>
            <Button
              size="sm"
              data-testid="logout-button"
              onClick={logout}
              className="rounded-full bg-white/10 hover:bg-white/20 text-white border border-white/20 font-semibold"
            >
              <LogOut className="h-4 w-4 sm:mr-1" /> <span className="hidden sm:inline">{t("nav.logout")}</span>
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-8 py-10">{children}</main>
    </div>
  );
}
